
        
const main = async(UX) => {
    const $subdueSidebar = Array.prototype.slice.call(document.getElementsByClassName('js--subdue-sidebar-height')),
        $toggleTable = Array.prototype.slice.call(document.getElementsByClassName('expandable')),
        $audioPlayer = Array.prototype.slice.call(document.getElementsByClassName('js-audio-player')),
        $clientPagination = Array.prototype.slice.call(document.getElementsByClassName('client-pagination')),
        $favorites = Array.prototype.slice.call(document.getElementsByClassName('favoriteShortlist')),
        $connectProfileMenu = document.querySelector('.connect-profile'),
        $loi = Array.prototype.slice.call(document.getElementsByClassName('loi__banner')),
        $disableADBlocker = Array.prototype.slice.call(document.getElementsByClassName('disable-adblocker__continue-btn')),
        $listOfIssuesAccordion = Array.prototype.slice.call(document.querySelectorAll('.loi-accordion, .loi-accordion__nested')),
        $showRecommended = Array.prototype.slice.call(document.getElementsByClassName('show-recommended-placeholder')),
        $axelPublicationContent = document.querySelector('article[data-design]'),
        $authorGuidelines = Array.prototype.slice.call(document.getElementsByClassName('custom-content__guidelines-nav')),
        $truncate = document.querySelector('.js--truncate, .issue-item, .do__header, .recommended-articles, .teaser__item, .fresh-pub__item'),
        $slideshow = document.querySelector('.slideshow,.slideShow, .js-showcase-slideshow'),
        $sections = document.querySelector('.toc'),
        $profile = document.querySelector('.institutionList, .profile-menu, .trusted-proxy-form, #institutionUsageReport, .alerts, #institutionUsageReport, .device-pairing__devices, .admin-manage-alerts, #pairingManagmentWidgetId, #holdingsForm'),
        $search = document.querySelector('.refineSearch,.advanced-search, .facet, .range-slider, .search-result, .advanced-search'),
        $pd = document.querySelector('.js-editable, .js-counter, .sortable-table, .autosave-form, .pd-pdf, .pd-action-bar, .submission-authors, .basic-metadata, .funders, .draftForm, .taxonomies-input-group, .submission-list, .supplemental-files, .supplemental-links, .author-index, .authorsHistoryWidget, .advisorActionRecords, .scp')
let promiseVariable = {};
try {
        if ($subdueSidebar.length) { 
            promiseVariable.subdueSidebarPromise = await import (
    /* webpackChunkName: "subdueSidebar" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/plugins/subduedSidebarHeight/js/subduedSidebarHeight'
)


UX.subdueSidebar.init($subdueSidebar);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($toggleTable.length) { 
            promiseVariable.toggleTablePromise = await import (
    /* webpackChunkName: "toggleTable" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/node_modules/ui-core/components/tables/js/tables'
)


UX.toggleTable.init($toggleTable);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($audioPlayer.length) { 
            promiseVariable.audioPlayerPromise = await import (
    /* webpackChunkName: "audioPlayer" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/node_modules/ui-core/components/audio-player/js/audio-player'
)

        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($clientPagination.length) { 
            promiseVariable.clientPaginationPromise = await import (
    /* webpackChunkName: "clientPagination" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/node_modules/ui-core/components/client-pagination/js/client-pagination'
)


UX.clientPagination.init($clientPagination);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($favorites.length) { 
            promiseVariable.favoritesPromise = await import (
    /* webpackChunkName: "favorites" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/node_modules/ui-core/widgets/favorites/js/favorites'
)


UX.favorites.init($favorites);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($connectProfileMenu) { 
            promiseVariable.connectProfileMenuPromise = await import (
    /* webpackChunkName: "connectProfileMenu" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/node_modules/ui-core/widgets/connect-profile-menu/js/connect-profile-menu'
)

const { default: ConnectProfileMenu } = await promiseVariable.connectProfileMenuPromise
UX.connectProfileMenu = new ConnectProfileMenu($connectProfileMenu).initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($loi.length) { 
            promiseVariable.loiPromise = await import (
    /* webpackChunkName: "loi" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/widgets/list-of-issues-detailed/js/list-of-issues-detailed'
)


UX.loi.init($loi);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($disableADBlocker.length) { 
            promiseVariable.disableADBlockerPromise = await import (
    /* webpackChunkName: "disableADBlocker" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/node_modules/ui-core/widgets/disable-adblocker/js/disable-adblocker'
)

        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($listOfIssuesAccordion.length) { 
            promiseVariable.listOfIssuesAccordionPromise = await import (
    /* webpackChunkName: "listOfIssuesAccordion" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/node_modules/ui-core/widgets/list-of-issues-detailed/js/list-of-issues-accordion'
)


UX.listOfIssuesAccordion.init($listOfIssuesAccordion);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($showRecommended.length) { 
            promiseVariable.showRecommendedPromise = await import (
    /* webpackChunkName: "showRecommended" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/node_modules/ui-core/widgets/show-recommended/js/show-recommended'
)


UX.showRecommended.init($showRecommended);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($axelPublicationContent) { 
            promiseVariable.axelPublicationContentPromise = await import (
    /* webpackChunkName: "axel-publication-content" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/widgets/axel-publication-content/js/axel-publication-content'
)

        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($authorGuidelines.length) { 
            promiseVariable.authorGuidelinesPromise = await import (
    /* webpackChunkName: "authorGuidelines" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/templates/author-guidelines/js/author-guidelines'
)


UX.authorGuidelines.init($authorGuidelines);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($truncate) { 
            promiseVariable.truncatePromise = await import (
    /* webpackChunkName: "truncate" */ 
    './groups/_truncate'
)

const { default: truncateMain } = await promiseVariable.truncatePromise
truncateMain(UX)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($slideshow) { 
            promiseVariable.slideshowPromise = await import (
    /* webpackChunkName: "slideshow" */ 
    './groups/_slideshow'
)

const { default: slideshowMain } = await promiseVariable.slideshowPromise
slideshowMain(UX)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($sections) { 
            promiseVariable.sectionsPromise = await import (
    /* webpackChunkName: "sections" */ 
    './groups/_sections'
)

const { default: sectionsMain } = await promiseVariable.sectionsPromise
sectionsMain(UX)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($profile) { 
            promiseVariable.profilePromise = await import (
    /* webpackChunkName: "profile" */ 
    './groups/_profile'
)

const { default: profileMain } = await promiseVariable.profilePromise
profileMain(UX)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($pd) { 
            promiseVariable.pdPromise = await (async () => {
    await Promise.all([promiseVariable.truncatePromise].filter(promise => !!promise));
    return await import (
    /* webpackChunkName: "pd" */ 
    './groups/_pd'
)
;
})();
const { default: pdMain } = await promiseVariable.pdPromise
pdMain(UX)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($search) { 
            promiseVariable.searchPromise = await (async () => {
    await Promise.all([promiseVariable.truncatePromise].filter(promise => !!promise));
    return await import (
    /* webpackChunkName: "search" */ 
    './groups/_search'
)
;
})();
const { default: searchMain } = await promiseVariable.searchPromise
searchMain(UX)
        }
    } catch (err) {
        console.error(err);
    }
    
return promiseVariable
}


        export default main;
        